import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import AppLayout from './components/Layout/AppLayout';
import BHELLayout from './components/Layout/BHELLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import TLDashboard from './pages/TLDashboard';
import TicketList from './pages/Tickets/TicketList';
import TicketDetail from './pages/Tickets/TicketDetail';
import NewTicket from './pages/Tickets/NewTicket';
import DeviceInventory from './pages/DeviceInventory';
import Spares from './pages/Spares';
import Attendance from './pages/Attendance';
import AgentsPage from './pages/Agents';
import Settings from './pages/Settings';
import Documents from './pages/Documents';
import RMATickets from './pages/RMATickets';
import RMATicketDetail from './pages/RMATickets/RMATicketDetail';
import PMTickets from './pages/PMTickets';
import AMTickets from './pages/AMTickets';
import BHELDashboard from './pages/BHEL/Dashboard';
import BHELMyLocation from './pages/BHEL/MyLocation';
import BHELTickets from './pages/BHEL/Tickets';
import BHELNewTicket from './pages/BHEL/NewTicket';
import BHELTicketDetail from './pages/BHEL/TicketDetail';
import BHELLocationDetail from './pages/BHEL/LocationDetail';
import BHELPMReportView from './pages/BHEL/PMReportView';
import BHELAttendance from './pages/BHEL/Attendance';
import AdminHub from './pages/Admin';
import MyHR from './pages/MyHR';

const BHEL_ROLES = ['BHEL_SPOC', 'BHEL_MANAGEMENT'];

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('access_token');
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  if (!token) return <Navigate to="/login" replace />;
  if (BHEL_ROLES.includes(user.role)) return <Navigate to="/bhel/dashboard" replace />;
  return children;
};

const BHELRoute = ({ children }) => {
  const token = localStorage.getItem('access_token');
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  if (!token) return <Navigate to="/login" replace />;
  if (!BHEL_ROLES.includes(user.role)) return <Navigate to="/dashboard" replace />;
  return children;
};

function RoleRedirect() {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  if (user.role === 'BHEL_MANAGEMENT') return <Navigate to="/bhel/dashboard" replace />;
  if (user.role === 'BHEL_SPOC') return <Navigate to="/bhel/my-location" replace />;
  return <Navigate to="/dashboard" replace />;
}

export default function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
            <Route index element={<RoleRedirect />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="tl-dashboard" element={<TLDashboard />} />
            <Route path="tickets" element={<TicketList />} />
            <Route path="tickets/new" element={<NewTicket />} />
            <Route path="tickets/:id" element={<TicketDetail />} />
            <Route path="inventory" element={<DeviceInventory />} />
            <Route path="devices" element={<DeviceInventory />} />
            <Route path="locations" element={<DeviceInventory />} />
            <Route path="spares" element={<Spares />} />
            <Route path="attendance" element={<Attendance />} />
            <Route path="agents" element={<AgentsPage />} />
            <Route path="settings" element={<Settings />} />
            <Route path="documents" element={<Documents />} />
            <Route path="rma-tickets" element={<RMATickets />} />
            <Route path="rma-tickets/:id" element={<RMATicketDetail />} />
            <Route path="pm-tickets" element={<PMTickets />} />
            <Route path="am-tickets" element={<AMTickets />} />
            <Route path="admin" element={<AdminHub />} />
            <Route path="admin/:tab" element={<AdminHub />} />
            <Route path="my-hr/*" element={<MyHR />} />
          </Route>
          <Route path="/bhel" element={<BHELRoute><BHELLayout /></BHELRoute>}>
            <Route index element={<Navigate to="/bhel/dashboard" replace />} />
            <Route path="dashboard" element={<BHELDashboard />} />
            <Route path="my-location" element={<BHELMyLocation />} />
            <Route path="location/:id" element={<BHELLocationDetail />} />
            <Route path="tickets" element={<BHELTickets />} />
            <Route path="tickets/new" element={<BHELNewTicket />} />
            <Route path="tickets/:id" element={<BHELTicketDetail />} />
            <Route path="pm-report/:ticketId" element={<BHELPMReportView />} />
            <Route path="attendance" element={<BHELAttendance />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </Provider>
  );
}
